// catering-builder.js — FINAL: 2-MEAT & 3-MEAT (SAME BEHAVIOR)
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('catering-form');
  if (!form) return;

  const els = {
    variantId: form.dataset.variantId,
    meatCount: parseInt(form.dataset.meatCount),
    guests: document.getElementById('guests'),
    delivery: document.getElementById('deliveryMethod'),
    meats: document.querySelectorAll('.meat'),
    sides: document.querySelectorAll('.side'),
    plates: document.getElementById('plates'),
    teaUnsweet: document.getElementById('teaUnsweet'),
    teaSweet: document.getElementById('teaSweet'),
    lemonade: document.getElementById('lemonade'),
    warmers: document.getElementById('warmers'),
    notes: document.getElementById('notes'),
    error: document.getElementById('cateringError'),
    btn: document.getElementById('addToCart'),
    meatCountSpan: document.getElementById('meatCount'),
    meatCountDisplay: document.getElementById('meatCountDisplay')
  };

  els.meatCountSpan.textContent = els.meatCount;
  els.meatCountDisplay.textContent = els.meatCount;

  // Variant IDs (same for both)
  const VARIANT = {
    DELIVERY_LOCAL: '45427502383303',  // $50
    DELIVERY_EXTENDED: '45427503562951', // $75
    PLATES: '45427501924551',
    TEA_UNSWEET: '45427501498567',
    TEA_SWEET: '45427494682823',
    LEMONADE: '45427493044423',
    WARMERS: '45427494158535',
    SUB_RIBS: '45427491176647',
    SUB_BRISKET: '45427487342791'
  };

  // Validation
  const validate = () => {
    els.error.style.display = 'none';
    const guests = parseInt(els.guests.value) || 0;
    if (guests < 5) return showError('Minimum 5 guests');
    if (!els.delivery.value) return showError('Select delivery method');

    const checkedMeats = Array.from(els.meats).filter(c => c.checked);
    const subs = checkedMeats.filter(c => c.classList.contains('meat-sub')).length;
    const regular = checkedMeats.length - subs;
    const valid = (regular === els.meatCount && subs === 0) || (regular === els.meatCount - 1 && subs === 1);
    if (!valid) return showError(`Select exactly ${els.meatCount} meats`);

    const checkedSides = Array.from(els.sides).filter(c => c.checked);
    if (checkedSides.length !== 2) return showError('Select exactly 2 sides');

    return true;
  };

  const showError = (msg) => {
    els.error.textContent = msg;
    els.error.style.display = 'block';
  };

  // Add to Cart
  els.btn.addEventListener('click', async () => {
    if (!validate()) return;

    const guests = parseInt(els.guests.value);
    const deliveryVariant = els.delivery.selectedOptions[0].dataset.variant;

    const items = [{
      id: els.variantId,
      quantity: guests,
      properties: {
        'Guests': guests,
        'Meats': Array.from(els.meats).filter(c => c.checked).map(c => c.value).join(' | '),
        'Sides': Array.from(els.sides).filter(c => c.checked).map(c => c.value).join(' | '),
        'Notes': els.notes.value.trim()
      }
    }];

    // Delivery as separate product
    if (deliveryVariant) {
      items.push({ id: deliveryVariant, quantity: 1, properties: { Type: 'Delivery Fee' } });
    }

    // Add-ons
    if (els.plates.checked) items.push({ id: VARIANT.PLATES, quantity: guests, properties: { Type: 'Plates & Utensils' } });
    if (parseInt(els.teaUnsweet.value)) items.push({ id: VARIANT.TEA_UNSWEET, quantity: parseInt(els.teaUnsweet.value), properties: { Type: 'Unsweet Tea' } });
    if (parseInt(els.teaSweet.value)) items.push({ id: VARIANT.TEA_SWEET, quantity: parseInt(els.teaSweet.value), properties: { Type: 'Sweet Tea' } });
    if (parseInt(els.lemonade.value)) items.push({ id: VARIANT.LEMONADE, quantity: parseInt(els.lemonade.value), properties: { Type: 'Lemonade' } });
    if (parseInt(els.warmers.value)) items.push({ id: VARIANT.WARMERS, quantity: parseInt(els.warmers.value), properties: { Type: 'Warmers' } });

    // Subs
    const sub = document.querySelector('.meat-sub:checked');
    if (sub) {
      const id = sub.value.includes('Ribs') ? VARIANT.SUB_RIBS : VARIANT.SUB_BRISKET;
      items.push({ id, quantity: guests, properties: { Type: sub.value } });
    }

    els.btn.disabled = true;
    els.btn.textContent = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error();
      window.location.href = '/cart';
    } catch (e) {
      showError('Failed to add to cart');
      els.btn.disabled = false;
      els.btn.textContent = 'Add to Cart';
    }
  });
});